import {createSlice} from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  currentPage: 0,
  hasNext: false,
  hasPrev: false,
  consultations: [],
  error: "",
}

const consultationSlice = createSlice({
  name: "consultationSlice",
  initialState: initialState,
  reducers: {
    fetchConsultationList: () => {
    },
    refundConsultation: () => {
    },
    setLoading: (state) => {
      state.loading = true;
    },
    setConsultationList: (state, action) => {
      state.currentPage = action.payload.page
      state.hasNext = action.payload.has_next
      state.hasPrev = action.payload.has_prev
      state.consultations = action.payload.data
      state.loading = false;
    },
    setError: (state, action) => {
      state.error = action.payload
      state.loading = false
    }
  },
});

export const {
  fetchConsultationList,
  refundConsultation,
  setLoading,
  setConsultationList,
  setError
} = consultationSlice.actions;
export default consultationSlice.reducer;